// extracted by mini-css-extract-plugin
module.exports = {"items":"index_items_Dp-cb","item":"index_item_2brs7"};